module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAiCAMAAAAJbCvNAAAAD1BMVEVMaXFJSEZJSEZJSEZJSEZeYRY9AAAABHRSTlMAD+ZKJuLdQwAAAEFJREFUeNrtzjEOACAIBEEE/v9mr5BoTC4WEiq2gIIpkJ2fSZQA/FECQPwnzFyAPWI3aPAH7soBK4A6SRcwItRwnPTfB3fNpSsTAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/mobileb/ic_ljt.png
// module id = jqvf
// module chunks = 1